import styled from "styled-components";
import { Link } from "react-router-dom";

const bp = { md: "768px", lg: "1100px" };

const c = {
  black: "#1e1e1e",
  gold: "#c9a227",
  pink: "#fc9ac4",
  pinkStrong: "#ff77b4",
  white: "#ffffff",
};

export const Page = styled.div`
  min-height: 100vh;
`;

export const Container = styled.div`
  @media (max-width: ${bp.md}) {
  }
`;

export const FullImageHero = styled.section`
  margin-top: 20px;
  width: 100%;
  overflow: hidden;
  background: #1e1e1e;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  @media (max-width: ${bp.md}) {
    margin-top: 90px;
  }
`;
